/* =============================================================
   AADHAV ACADEMY – PROFIT & LOSS SELECTORS (UNIVERSAL)
============================================================= */

/**
 * BASE STATE SELECTOR
 */
export const selectProfitLossState = (state) =>
  state?.admin?.profitLoss ?? {};

/**
 * DATA SELECTOR
 */
export const selectProfitLossData = (state) => {
  const sliceState = selectProfitLossState(state);
  
  // 1. If stored as state.data.data
  if (sliceState.data && Array.isArray(sliceState.data.data)) {
    return sliceState.data.data;
  }

  // 2. If stored directly as state.data
  if (Array.isArray(sliceState.data)) {
    return sliceState.data;
  }

  return [];
};

/**
 * SUMMARY SELECTOR
 * Checks both root slice level and nested payload level to extract figures safely.
 */
export const selectProfitLossSummary = (state) => {
  const sliceState = selectProfitLossState(state);

  // Path A: Check if it's stored directly at the root slice level (state.summary)
  if (sliceState.summary && (sliceState.summary.income !== undefined || sliceState.summary.expense !== undefined)) {
    return sliceState.summary;
  }

  // Path B: Check if it's nested inside the data wrapper (state.data.summary)
  if (sliceState.data && sliceState.data.summary) {
    return sliceState.data.summary;
  }

  // Fallback defaults
  return {
    income: 0,
    expense: 0,
    profit: 0,
  };
};

/**
 * LOADING STATE SELECTOR
 */
export const selectProfitLossLoading = (state) =>
  Boolean(selectProfitLossState(state).loading);

/**
 * ERROR SELECTOR
 */
export const selectProfitLossError = (state) =>
  selectProfitLossState(state).error ?? null;